export const USER_MANAGEMENT = "User Management";
export const ADMIN_PANEL_USERS = "Admin Panel Users";
export const MOBILE_PANEL_USERS = "Mobile App Users";
export const USER_DETAILS = "User Details";
export const MEDIA_MANAGEMENT = "Media Management";
export const CONTENT_MANAGEMENT = "Content Management";
export const YOUTUBE = "YouTube";
export const BANNERS = "Banners";
export const ADD_BANNER = "Add Banner";
export const VIEW_BANNER = "View Banner";
export const EDIT_BANNER = "Edit Banner";
export const NOTIFICATIONS = "Notifications";
export const ADD_NOTIFICATIONS = "Add Notifications";
export const EDIT_NOTIFICATIONS = "Edit Notifications";
export const SEND_NOTIFICATIONS = "Send Notifications";
export const INSTAGRAM = "Instagram";
export const CONTENT_DETAIL = "Content Detail";
export const SUBSCRIPTION = "Subscription";
export const TRANSACTION_HISTORY = "Transaction History";
export const ACTIVITY_LOGS = "Activity Logs";
export const USER_ACTIVITY_LOGS = "User Activity Logs";

//internal nav tabs constants
export const USERS = "Users";
export const TOPICS = "Topics";

//flags
export const YOU_TUBE = "youtube";
export const FORCE_LOGOUT = "force_logout";

//app version
export const APP_VERSION = "0.1.38";

export const COMMON_STOP_WORDS = [
  "is",
  "am",
  "are",
  "was",
  "were",
  "be",
  "being",
  "been",
  "on",
  "the",
  "a",
  "have",
  "has",
  "had",
  "do",
  "does",
  "did",
  "we",
  "will",
  "would",
  "shall",
  "should",
  "can",
  "could",
  "may",
  "might",
  "must",
  "about",
];
